import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout/Layout.js";
import Home from "./pages/Home.js";
import Employers from "./pages/Employers.js";
import Candidates from "./pages/Candidates.js";
import About from "./pages/About.js";
import Contact from "./pages/Contact.js";
import Team from "./pages/Team.js";
import EngineerSignUp from "./pages/EngineerSignUp.js";
import CompanySignUp from "./pages/CompanySignUp.js";
import Login from "./pages/Login.js";
import AuthCallback from "./pages/AuthCallback.js";
import MagicLinkVerify from "./pages/MagicLinkVerify.js";
import AdminDashboard from "./pages/AdminDashboard.js";
import CompleteProfile from "./pages/CompleteProfile.js";
import EngineerDashboard from "./pages/EngineerDashboard.js";
import CompanyOnboarding from "./pages/CompanyOnboarding.js";
import MatchResults from "./pages/MatchResults.js";
import NotFound from "./pages/NotFound.js";
import AuthGuard from "./components/AuthGuard.js";
import { AuthProvider } from "./contexts/AuthContext.js";

export default function App() {
  const location = useLocation();

  return (
    <AuthProvider>
      <Routes location={location} key={location.pathname}>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/employers" element={<Employers />} />
          <Route path="/candidates" element={<Candidates />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signup/engineer" element={<EngineerSignUp />} />
          <Route path="/signup/company" element={<CompanySignUp />} />
          <Route path="/login" element={<AuthGuard><Login /></AuthGuard>} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/magic-link/verify" element={<MagicLinkVerify />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/complete-profile" element={<CompleteProfile />} />
          <Route path="/engineer/dashboard" element={<EngineerDashboard />} />
          <Route path="/company/onboarding" element={<CompanyOnboarding />} />
          <Route path="/company/matches" element={<MatchResults />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
